import React from "react";
import { Box, Button, Typography } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useAuth } from "../../contexts/authentication/AuthenticationContext";

export const ImpersonationBanner: React.FC = () => {
  const authContext = useAuth();

  if (!authContext?.isImpersonation) {
    return null;
  }

  return (
    <Box
      sx={{
        zIndex: 9998,
        bgcolor: "#f19f13",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 3,
        py: 0.75,
        gap: 2,
        mb: 3,
      }}
    >
      <Box display="flex" alignItems="center" gap={1.5}>
        <VisibilityIcon fontSize="small" />
        <Typography variant="body2" fontWeight={500}>
          Visualizando como:
        </Typography>
        <Typography variant="body2" fontWeight={700}>
          {authContext.impersonatedUserName}
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.8 }}>
          ({authContext.impersonatedUserEmail})
        </Typography>
      </Box>

      <Button
        size="small"
        variant="outlined"
        onClick={() => authContext?.stopImpersonation?.()}
        sx={{
          color: "#fff",
          borderColor: "rgba(255,255,255,0.6)",
          whiteSpace: "nowrap",
          "&:hover": {
            borderColor: "#fff",
            bgcolor: "rgba(255,255,255,0.1)",
          },
        }}
      >
        Encerrar impersonação
      </Button>
    </Box>
  );
};
